import BConfig from "../BConfig";
import BForm from "../BForm";
import BRequest from "../BRequest";
import BScroll from "../BScroll";

export default class BCaloricCalculator
{
	constructor(el) {
		this.el = el;
	}

	getForm()
	{
		return new BForm(this.el);
	}

	getResult()
	{
		this.getForm().resetErrors();

		this.sendRequest(this.getForm().getData()).then(response => {
			this.setResponse(response);
		}).catch(error => {
			try {
				this.scrollToTop();
			} catch (error) {
				// Nevermind.
			}

			this.getForm().setErrorResponse(error);
		});
	}

	sendRequest(data)
	{
		return BRequest.get(BConfig.getRoute("api.v2.caloricCalculator.getMetrics"), data);
	}

	scrollToTop()
	{
		BScroll.top(this.el);
	}

	setOutputMetric(metric)
	{
		try {
			const selector = `.caloric-calculator__output [data-metric="${metric.name}"] .result`;
			this.el.querySelectorAll(selector).forEach(el => {
				el.innerHTML = metric.formatted;
			});
		} catch (error) {
			console.debug(error);
		}

		try {
			const selector = `.caloric-calculator__output .caloric-meter[data-metric="${metric.name}"] .pointer`;
			this.el.querySelectorAll(selector).forEach(el => {
				el.setAttribute(`style`, `transform: rotate(${90 + (112.5 * metric.result)}deg)`);
			});
		} catch (error) {
			console.debug(error);
		}
	}

	showInput()
	{
		this.el.querySelector(`.caloric-calculator__input`).removeAttribute('hidden');
	}

	hideInput()
	{
		this.el.querySelector(`.caloric-calculator__input`).setAttribute('hidden', '');
	}

	showOutput()
	{
		this.el.querySelector(`.caloric-calculator__output`).removeAttribute('hidden');

		try {
			window.nutriangle();
		} catch (error) {
			// Yeah...
		}
	}

	hideOutput()
	{
		this.el.querySelector(`.caloric-calculator__output`).setAttribute('hidden', '');
	}
}
